import * as React from 'react';
import { Route, Routes } from 'react-router';
import ErrorBoundary from 'Common/pages/error';
import withWaitingComponent from 'Common/HOC/withWaitingComponent';

const LiveReportsScreen = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LiveReportsModule" */
      './screens/Live'
    )
);

const DownloadReportsScreen = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DownloadReportsModule" */
      './screens/Downloads'
    )
);

const ReportsRouter: React.FC = () => (
  <Routes>
    <Route path="live" element={withWaitingComponent(LiveReportsScreen)} />
    <Route
      path="downloads"
      element={withWaitingComponent(DownloadReportsScreen)}
    />
    <Route path="*" element={<ErrorBoundary />} />
  </Routes>
);

export default ReportsRouter;
